// export {default as SalesList} from './List'
import '../Reports.css'

export { default as CostoVentasReport } from './Report'
